import React, { PropsWithChildren } from 'react';
import cn from 'classnames';
import { PropsWithTestId } from '../../../../../../types';
import { DiscoveryContentTypes } from '../../../../../../constants';
import { CONTENT_TYPES_DATA_MAP } from '../../../constants';
import styles from './Input.module.scss';

export function getLabel(label: string) {
  if (label.toLowerCase() === DiscoveryContentTypes.ALL) {
    return CONTENT_TYPES_DATA_MAP[DiscoveryContentTypes.ALL].heading;
  }

  return label;
}

export interface InputProps {
  label: string;
  count?: number;
  disabled?: boolean;
}

export function Input(props: PropsWithTestId<PropsWithChildren<InputProps>>) {
  const { label, disabled, count, children, testId } = props;

  const wrapperClassName = cn(styles.wrapper, {
    [styles.disabled]: disabled,
  });

  return (
    <label data-testid={testId} className={wrapperClassName}>
      <span className={styles.inputWrapper}>
        <span className={styles.input}>{children}</span>
        <span className={styles.label}>{getLabel(label)}</span>
      </span>
      <span className={styles.count}>{count === 10000 ? '10000+' : count}</span>
    </label>
  );
}

Input.defaultProps = {
  count: 0,
  testId: 'input',
};
